<template>
	<div class="customer-car-form" style="position:relative;">
		<div class="card" v-show="!sent">

			<div class="card-body text-left">

				<form class="order-form" id="customerFormTop">
					<div class="mb-2">
						<div class="form-control-required-wrapper flatpickr-wrapper"  :class="(!isDateStartValid && send_clicked) ? 'is-invalid' : ''">
							<span class="form-control-required-star">
								<span class="star" :class="isDateStartValid ? 'star-valid' : ''">*</span>
							</span>

							<flat-pickr
								v-model="date_start"
								:config="flatPicker_config_start"
								class="form-control"
								:placeholder="t.date_start_label[locale]"
								name="date1">
							</flat-pickr>
						</div>
						<div v-if="!isDateStartAfterFree" class="text-danger my-1 fs-7">{{t.form_error_start_date[locale]}}</div>
					</div>


					<!--					{{time_start}}-->

					<div class="mb-2">
						<div class="form-control-required-wrapper"  :class="(!isTimeStartValid && send_clicked) ? 'is-invalid' : ''">
							<span class="form-control-required-star">
								<span class="star" :class="isTimeStartValid ? 'star-valid' : ''">*</span>
							</span>

							<select v-model="time_start"
							        id="form-select"
							        required
							        class="form-select">
								<option value="" disabled selected hidden>{{t.time_start_label[locale]}}</option>
								<option v-for="(item, index) in time_list"
								        :key="index"
								        v-if="timeIsAvailable(item)"
								        :value="item">
									{{item}}
								</option>
							</select>
						</div>
					</div>


					<!--					{{date_end}}-->
					<div class="mb-2">
						<div class="form-control-required-wrapper flatpickr-wrapper"  :class="(!isDateEndValid && send_clicked) ? 'is-invalid' : ''">
							<span class="form-control-required-star">
								<span class="star" :class="isDateEndValid ? 'star-valid' : ''">*</span>
							</span>

							<flat-pickr
								v-model="date_end"
								:config="flatPicker_config_end"
								class="form-control"
								:placeholder="t.date_end_label[locale]"
								name="date2">
							</flat-pickr>
						</div>
					</div>

					<!--					{{time_end}}-->
					<div class="mb-2">
						<div class="form-control-required-wrapper"  :class="(!isTimeEndValid && send_clicked) ? 'is-invalid' : ''">
							<span class="form-control-required-star">
								<span class="star" :class="isTimeEndValid ? 'star-valid' : ''">*</span>
							</span>

							<select v-model="time_end"
							        required
							        class="form-select">
								<option value="" disabled selected hidden>{{t.time_end_label[locale]}}</option>
								<option v-for="(item, index) in time_list"
								        :key="index"
								        :value="item">
									{{item}}
								</option>
							</select>

						</div>
					</div>


					<div class="mb-2">
						<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isNameValid ? 'star-valid' : ''">*</span>
							</span>
							<input class="form-control shadow-none form-control-required"
							       :class="(!isNameValid && send_clicked) ? 'is-invalid' : ''"
							       name="name" v-model="name" :placeholder="t.name_label[locale]">
						</div>
					</div>



					<div class="mb-2">
						<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isSurnameValid ? 'star-valid' : ''">*</span>
							</span>
							<input class="form-control shadow-none form-control-required"
							       :class="(!isSurnameValid && send_clicked) ? 'is-invalid' : ''"
							       name="name" v-model="surname" :placeholder="t.surname_label[locale]">
						</div>
					</div>


					<div class="mb-2">
						<div class="form-control-required-wrapper"  :class="(!isBirthDateValid && send_clicked) ? 'is-invalid' : ''">
							<span class="form-control-required-star">
								<span class="star" :class="isBirthDateValid ? 'star-valid' : ''">*</span>
							</span>
							<div class="d-flex w-100  justify-content-between">
								<div class="flex-fill">
									<select name="year" v-model="dob_year" required class="form-select ps-3" :class="(!isBirthDateValid && !dob_year && send_clicked ? 'is-invalid' : '')">
										<option value="" disabled selected hidden>{{t.birthdate_label[locale]}}</option>
										<option :value="year" v-for="year in yearsList" :key="year">{{year}}</option>
									</select>
								</div>
								<div class="flex-fill">
									<select name="month" v-model="dob_month" required class="form-select form-select--no-padding" :class="(!isBirthDateValid && !dob_month && send_clicked ? 'is-invalid' : '')">
										<option value="" disabled selected hidden>{{t.birthdate_month_label[locale]}}</option>
										<option :value="key" v-for="(value, key, index) in month_list[locale]" :key="key">{{value}}</option>
									</select>
								</div>

								<div class="flex-fill">
									<select name="date"  v-model="dob_day" required class="form-select form-select--no-padding" :class="(!isBirthDateValid && !dob_day && send_clicked ? 'is-invalid' : '')">
										<option value="" disabled selected hidden>{{t.birthdate_date_label[locale]}}</option>
										<option  :value="day" v-for="day in daysList" :key="day" >{{ day }}</option>
									</select>
								</div>

							</div>
						</div>
						<div v-if="!isAgeValid && send_clicked" class="text-danger my-1 fs-7">{{t.form_error_age[locale]}}</div>
					</div>




					<!--	        -->

					<div class="mb-2">
						<div class="phone-wrapper">
							<div class="form-control-required-wrapper">

								<input class="form-control shadow-none form-control-required"
								       ref="phoneInput1"
								       :class="(send_clicked && !isPhone1oRPhone2WithWhatsAppValid) ? 'is-invalid' : ''"
								       name="phone" v-model="phone" :placeholder="t.phone_title[locale]">
							</div>
							<div class="phone-whatsapp-checkbox">
								<div class="form-check custom-control-lg">
									<input class="form-check-input"
									       type="checkbox"
									       :disabled="!isPhoneValid || !phone.length"
									       v-model="whats_app"
									       true-value="1" false-value="0"
									       value="" id="whatsAppCheck">
									<label class="form-check-label" for="whatsAppCheck">
										WhatsApp
									</label>
								</div>
							</div>
						</div>

					</div>





					<div class="mb-2 phone-wrapper">
						<div class="phone-wrapper">
							<div class="form-control-required-wrapper">

								<input class="form-control shadow-none form-control-required"
								       ref="phoneInput2"
								       :class="(send_clicked && !isPhone1oRPhone2WithWhatsAppValid) ? 'is-invalid' : ''"
								       name="phone" v-model="phone2" :placeholder="t.phone2_title[locale]">
							</div>
							<div class="phone-whatsapp-checkbox">
								<div class="form-check custom-control-lg">
									<input class="form-check-input" type="checkbox"
									       :disabled="!isPhone2Valid  || !phone2.length"
									       v-model="whats_app2"
									       true-value="1" false-value="0"
									       value="" id="whatsAppCheck2">
									<label class="form-check-label" for="whatsAppCheck2">
										WhatsApp
									</label>
								</div>
							</div>
						</div>
					</div>


					<div class="mb-2">
						<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isEmailValid ? 'star-valid' : ''">*</span>
							</span>
							<input class="form-control shadow-none form-control-required"
							       :class="(!isEmailValid && send_clicked) ? 'is-invalid' : ''"
							       name="email" v-model="email" :placeholder="t.email_label[locale]">
						</div>
					</div>




					<div v-if="(
						(!isWhatsAppValid && phone.length && !isWhatsApp2Valid) ||
					(!isPhone1oRPhone2WithWhatsAppValid && send_clicked)
					) "
					     class="text-danger fs-7 mb-3">{{t.form_error_whatsApp[locale]}}</div>


<!--					v-show="isDateStartValid && isDateEndValid && isTimeStartValid && isTimeEndValid && isEmailValid && isPhone1oRPhone2WithWhatsAppValid"-->

					<div
						class="mt-3">

						<div class="data_is_secure d-flex align-items-center mb-3">
							<i class="fas fa-shield-alt fa-lg"></i>
							<span class="secure-title ms-2">{{t.data_is_secure[locale]}}</span>
						</div>


						<div class="mb-2">
							<div
								:class="(!isPhotosValid && send_clicked) ? 'is-invalid invalid-file-wrapper' : ''"
								class="form-control-required-wrapper">
								<span class="form-control-required-star">
									<span class="star" :class="isPhotosValid ? 'star-valid' : ''">*</span>
								</span>
								<div class="input-group file-upload form-control d-flex flex-nowrap">
									<input type="file" name="file[]" multiple
									       accept="image/*,.heic,.heif"
									       @change="selectPhotos($event)"
									       class="d-none"
									       id="inputFile">
									<label class="input-group-label flex-grow-1 flex-shrink-1 d-flex align-items-center" for="inputFile">
										<span class="label-text-wrapper">{{t.photo_label[locale]}}</span>
									</label>
									<label class="input-group-text flex-grow-0" for="inputFile" role="button">{{t.photo_select_label[locale]}}</label>
								</div>
							</div>



							<div v-show="photos.length" class="photos-wrapper mt-2 mb-3">
								<div v-for="(photo,index) in photos" class="photo-wr">
									<div class="photo-holder">
										<div class="photo">
											<img id="blah" :src="photo.src" alt="" style="max-height:120px;">
											<div @click="removePhoto(index)" class="btn-delete btn btn-light btn-sm"><i class="fas fa-times"></i></div>
										</div>
									</div>
								</div>
							</div>

						</div>



						<div class="mb-2">
							<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isAddressValid ? 'star-valid' : ''">*</span>
							</span>
								<input class="form-control shadow-none form-control-required"
								       :class="(!isAddressValid && send_clicked) ? 'is-invalid' : ''"
								       name="address" v-model="address" :placeholder="t.address_label[locale]">
							</div>
						</div>


						<div class="mb-2">
							<div class="form-control-required-wrapper">
<!--	                            <span class="form-control-required-star">-->
<!--	                                <span class="star" :class="isAddressApartmentValid ? 'star-valid' : ''">*</span>-->
<!--	                            </span>-->
								<input class="form-control shadow-none form-control-required"
								       :class="(!isAddressApartmentValid && send_clicked) ? 'is-invalid' : ''"
								       name="address" v-model="address_apartment" :placeholder="t.address_apartment_label[locale]">
							</div>
						</div>




						<div class="mb-2">
							<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isAddressCityValid ? 'star-valid' : ''">*</span>
							</span>
								<input class="form-control shadow-none form-control-required"
								       :class="(!isAddressCityValid && send_clicked) ? 'is-invalid' : ''"
								       name="address" v-model="address_city" :placeholder="t.address_city_label[locale]">
							</div>
						</div>

						<div class="mb-2">
							<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isAddressStateValid ? 'star-valid' : ''">*</span>
							</span>
								<input class="form-control shadow-none form-control-required"
								       :class="(!isAddressStateValid && send_clicked) ? 'is-invalid' : ''"
								       name="address" v-model="address_state" :placeholder="t.address_state_label[locale]" readonly>
							</div>
						</div>


						<div class="mb-2">
							<div class="form-control-required-wrapper">
							<span class="form-control-required-star">
								<span class="star" :class="isAddressZipValid ? 'star-valid' : ''">*</span>
							</span>
								<input class="form-control shadow-none form-control-required"
								       :class="(!isAddressZipValid && send_clicked) ? 'is-invalid' : ''"
								       name="address" v-model="address_zip" :placeholder="t.address_zip_label[locale]">
							</div>
						</div>


						<div class="mb-2">
							<div class="input-group">
								<input class="form-control shadow-none" name="chairs" v-model="chairs" :placeholder="t.chairs_label[locale]">
								<div class="input-group-append">
								<span class="input-group-text" id="basic-addon1"
								      data-bs-container="body"
								      data-bs-toggle="popover"
								      data-bs-placement="top"
								      data-bs-trigger = "hover"
								      data-bs-html="true"
								      :data-bs-content="t.chairs_popover[locale]"
								>i</span>
								</div>
							</div>
						</div>


						<div class="mb-2">
							<textarea class="form-control shadow-none"
							          name="comment"
							          rows="3"
							          maxlength="1000"
							          v-model="comment"
							          :placeholder="t.comment_label[locale]"></textarea>
						</div>


					</div>


					<div class="my-3">
						<!--            {{isDatesValid}} - {{daysNumber}}-->
						<div class="price-row text-center">
							<span class="price-num">{{priceTotal | currency}}</span>
							<span class="price-month" v-show="!isDatesValid">/ {{t.month[locale]}}</span>
						</div>
					</div>


					<!--										<div v-show="admin === 'admin'">-->
					<!--										<div>-->
					<!--											<div>-->
					<!--												<br>id {{Number(id)}}-->
					<!--												<br>price {{Number(price)}}-->
					<!--												<br>isDatesValid: {{isDatesValid}}-->
					<!--												<br>daysNumberWithCorrection {{(extraHours > hours_limit ? fullDaysNumber + 1 : fullDaysNumber)}}-->

					<!--												<br>start: {{date_start}}  &#45;&#45;  {{time_start}}-->
					<!--												<br>start time valid: {{isTimeStartValid}}-->
					<!--												<br>end: {{date_end}}  &#45;&#45;  {{time_end}}-->
					<!--												<br>Выбрано дней: {{fullDaysNumber}}  ({{hoursNumber}} часов)-->
					<!--												|-->
					<!--												Часы опоздания: {{extraHours}}-->
					<!--											</div>-->

					<!--											<div class="border-1 border">-->
					<!--												Из админки:-->
					<!--												<br>Мax к-во дней, после доступности авто: {{days_before_start}}-->
					<!--												<br>Допустимое кол-во часов опоздания: {{hours_limit}}-->
					<!--												<br>Дата доступности {{date_free}} ({{date_free_fixed}})-->
					<!--												<br>Дней с доcтупности авто до дня бронирования -  ({{daysAfterFree}}) {{isStartDateNotToLate}}-->
					<!--											</div>-->
					<!--										</div>-->


					<div v-if="js_errors.length && send_clicked"  class="mt-3">
						<div v-for="error in js_errors"  class="alert alert-danger p-2 my-1">
							{{error}}
						</div>
					</div>



					<div v-if="server_errors && send_clicked" class="mt-3">
						<div v-for="(error,index) in server_errors" class="alert alert-danger p-2 my-1">
							<span v-if="t.server_errors_translations[index]">
								{{t.server_errors_translations[index][locale]}}</span>
						</div>
					</div>



					<div class="mb-2 mb-2-order-btn">
						<button class="btn btn-success btn-lg rounded-3 w-100"
						        :disabled="sending || (!isFormValid && send_clicked)"
						        @click.prevent="sendForm()">
							{{t.btn_name_send[locale]}}
							<i class="fas fa-spinner fa-pulse ms-1" v-show="sending"></i>
						</button>

						<div class="mt-2">
							{{t.btn_name_send_comment[locale]}}
						</div>
					</div>

				</form>

			</div>
		</div>

		<div v-show="sent"  class="box-sent"  id="sentTop">
			<div  v-if="server_warnings['available']" class="sent-text-top">
				{{t.server_warnings_translations['available'][locale]['title']}}
			</div>
			<div  v-else class="sent-text-top">
				{{t.form_msg_thanks[locale]}}
			</div>

			<div v-if="server_warnings['available']"  class="my-5 sent-icon sent-icon--warning">
				<i class="fa fa-exclamation" aria-hidden="true"></i>
			</div>
			<div v-else class="my-5 sent-icon">
				<i class="far fa-check-circle"></i>
			</div>

			<div class="my-5">
				<div v-if="server_warnings['available']" class="sent-text2" v-html="t.server_warnings_translations['available'][locale]['text']"></div>
				<div v-else class="sent-text2" v-html="t.form_msg_sended[locale]"></div>
			</div>
			<div class="btn-ok-wr">
				<a :href="(locale == 'en' ? '/' : '/' + locale + '/')">
					<span class="btn w-100 btn-lg btn-outline-success rounded-3 text-decoration-none">OK</span>
				</a>
			</div>
		</div>

	</div>
</template>

<script>
// Third-party imports
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Russian, Spanish, Portuguese, English } from "flatpickr/dist/l10n";
import moment from 'moment-timezone';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/en-gb';
//import heic2any from 'heic2any';

// intl-tel-input
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

// Local imports
import translations from "./translations";
import time_list from "./time_list";
import month_list from "./month_list";



export default {
	name: "customer-car-form-v2",
	props: ['admin','locale','id','price','car_name','lot_number','available','date_free','btn_name','btn_class',
		'hours_limit',
		'days_before_start'
	],
	components: {
		//VueCtkDateTimePicker,
		//VueDatePicker,
		//VueTimepicker,
		flatPickr
	},
	data() {
		return {
			t: translations,
			flatPicker_date: new Date(),
			// Get more form https://flatpickr.js.org/options/
			flatPicker_config_start: {
				wrap: true, // set wrap to true only when using 'input-group'
				altFormat: this.locale == 'ru' ? 'j M, Y' : 'M j, Y',
				altInput: true,
				dateFormat: 'Y-m-d',
				locale: this.locale,
				minDate: this.date_free ? new Date(moment(this.date_free)) : new Date(moment(this.min_date)),
				disableMobile: true
			},
			flatPicker_config_end: {
				wrap: true, // set wrap to true only when using 'input-group'
				altFormat: this.locale == 'ru' ? 'j M, Y' : 'M j, Y',
				altInput: true,
				dateFormat: 'Y-m-d',
				locale: this.locale,
				minDate: this.date_start ? new Date(moment(this.date_start)) : (this.date_free ? new Date(moment(this.date_free)) : new Date(moment(this.min_date))),
				disableMobile: true,
				monthSelectorType: 'static'
			},


			flatPicker_config_time: {
				enableTime: true,
				noCalendar: true,
				dateFormat: "H:i",
				minuteIncrement: 15,
				time_24hr: false,
				disableMobile: true,
				//defaultDate: "12:00"
			},

			time_list: time_list,
			month_list: month_list,
			dob_year: '',
			dob_month: '',
			dob_day: '',
			sent: false,
			sending: false,
			accept: false,
			accept_date: false,
			send_clicked:false,
			server_errors:{},
			server_warnings:{'available':'warning'},
			phone: '',
			phone2: '',
			whats_app: 0,
			whats_app2: 0,
			email: '',
			name: '',
			surname: '',
			note: '',
			address: '',
			address_apartment: '',
			address_city: '',
			address_state: '',
			address_zip: '',
			chairs: '',
			comment: '',
			flight: '',
			dates: '',
			menu: false,
			date_free_fixed: '',
			date_start: '',
			time_start: '',
			date_end: '',
			time_end: '',
			isPhoneErr: false,
			isPhone2Err: false,
			comments: '',
			isCommentsErr: false,
			photo_src: '#',
			photos: [],
			filesToUpload: [],
			phoneBecomeValid: false,
			iti1: null,
			iti2: null,
		}
	},

	computed: {

		birthdate() {
			if (!this.dob_year || !this.dob_month || !this.dob_day) {
				return null;
			}
			var bod = this.dob_year + '-' + this.dob_month + '-' + this.dob_day;
			// convert to correct Y-m-d format
			return moment(bod, "YYYY-MM-DD").format('YYYY-MM-DD');
		},


		min_date() {
			var currentDate = new Date()
			var day = currentDate.getDate();
			var month = currentDate.getMonth() + 1
			var year = currentDate.getFullYear()
			var today =( year + "-" + month + "-"  + day)
			return today;
		},


		priceTotal() {
			var total = this.price;
			if (!this.isDatesValid) {
				return (this.price);
			}

			let daysNumberWithCorrection = (this.extraHours > this.hours_limit ? this.fullDaysNumber + 1 : this.fullDaysNumber);

			if (daysNumberWithCorrection < 31) {
				return (Number(this.price) + 1);
			}

			total = Number((Number(this.price) + 1) * Math.floor(daysNumberWithCorrection / 30)) + Number( ((Number(this.price) + 1) / 30) * (daysNumberWithCorrection % 30));

			return Math.ceil(total);
		},


		daysNumber() {
			if (!this.isDatesValid) {
				return 0;
			}
			var a = moment(this.date_start, "YYYY-MM-DD");
			var b = moment(this.date_end, "YYYY-MM-DD");
			return b.diff(a, 'days');
		},


		hoursNumber() {
			if (!this.isDatesValid) {
				return 0;
			}
			// time in am/pm format we should convert it to 24 hours format first
			let time_start = moment(this.time_start, ["h:mm A"]).format("HH:mm");
			let time_end = moment(this.time_end, ["h:mm A"]).format("HH:mm");

			//var a = moment(this.date_start + ' ' + this.time_start, "YYYY-MM-DD HH:mm");
			//var b = moment(this.date_end + ' ' + this.time_end, "YYYY-MM-DD HH:mm");

			var a = moment(this.date_start + ' ' + time_start, "YYYY-MM-DD HH:mm");
			var b = moment(this.date_end + ' ' + time_end, "YYYY-MM-DD HH:mm");


			// hours with round up (if 1.5 hour = 2)
			//return b.diff(a, 'hours');
			return b.diff(a, 'hours', true);
		},


		fullDaysNumber() {
			if (!this.isDatesValid) {
				return 0;
			}

			let hours = this.hoursNumber;
			// hours to number full days
			let days = Math.floor(hours / 24);
			return days;
		},


		extraHours() {
			if (!this.isDatesValid) {
				return 0;
			}
			let hours = this.hoursNumber;
			// find number of extra hours. round up (if 1.5 hour = 2)
			//let extraHours = hours % 24;
			let extraHours = Math.ceil(hours % 24);

			return extraHours;
		},


		isDatesValid() {
			if (!this.isDateStartValid || !this.isDateEndValid) {
				return false;
			}

			return true;
		},


		yearsList() {
			// get years list for old 26-70
			var years = [];
			var date = new Date();
			var year = date.getFullYear();
			for (var i = year - 25; i >= year - 70; i--) {
				years.push(i);
			}
			return years;
		},


		daysList() {
			// get days list for 1-31
			var days = [];
			for (var i = 1; i <= 31; i++) {
				days.push(i);
			}
			return days;
		},


		isBirthDateValid() {
			if (!this.birthdate) {
				return false;
			}
			if (!this.birthdate) {
				return false;
			}
			if (!this.isAgeValid) {
				return false;
			}
			return true;
		},


		isAgeValid() {
			if (!this.birthdate) {
				return false;
			}


			// check if age not less than 18
			var a = moment(this.birthdate, "YYYY-MM-DD");
			var b = moment();
			var years = b.diff(a, 'years');
			if (years < 26) {
				return false;
			}
			if (years >= 70) {
				return false;
			}
			return true;
		},


		currentDateMinus70Years() {
			var date = new Date();
			date.setFullYear(date.getFullYear() - 70);
			return date.toISOString().split('T')[0];
		},


		isDateStartAfterFree() {
			return true;
			if (this.date_free && this.date_start) {
				// check if date_start (YYYY-MM-DD) is not before date_free
				var start = new Date(this.date_start + 'T' + this.time_start);
				var free = new Date(this.date_free);
				if (start < free) {
					return false;
				}
			}
			return true;
		},


		isDateStartValid() {
			const today = moment().tz("America/New_York").format('YYYY-MM-DD');
			const start = moment(this.date_start).format('YYYY-MM-DD');
			return this.date_start && start >= today;
		},


		isDateEndValid() {
			if (!this.date_end) {
				return false;
			}


			if (!this.date_end || this.date_end == null) {
				return false;
			}

			// check if date (YYYY-MM-DD) is not in the past
			var date = new Date();
			var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
			var end = new Date(this.date_end);
			if (end < today) {
				return false;
			}

			if (this.date_start) {
				let start = new Date(this.date_start);
				if (end < start) {
					return false;
				}
			}
			return true;
		},



		isTimeStartValid() {
			if (!this.time_start) {
				return false;
			}
			// check if hours set not to HH
			let hours = this.time_start.split(':')[0];
			if (hours == 'HH') {
				return false;
			}


			if (!this.time_start || this.time_start == null) {
				return false;
			}
			// if is today this.date_start check if time_start is not in the past by miami time
			if (this.isTodayInMiami(this.date_start)) {

				var start = new Date(this.date_start + 'T' + this.time_start);
				start = moment(start).format('YYYY-MM-DDTHH:mm');
				// today get miami current time using moment
				var today = moment().tz("America/New_York").format('YYYY-MM-DDTHH:mm');

				if (start < today) {
					//console.log('is past!!!!!');
					return false;
				} else {
					//console.log('is not past!');
				}
			} else {
				//console.log('is not today!!!!');
			}

			/// if selected date is the date when car is free check if time is not before time_free
			if (this.date_free) {
				// take only date from 2024-03-27 10:00:00
				var date_free = this.date_free.split(' ')[0];

				if (this.date_start == date_free) {

					// check if date_start (YYYY-MM-DD) is not before date_free
					var start = new Date(this.date_start + 'T' + this.time_start);
					var free = new Date(this.date_free);
					if (start < free) {
						return false;
					}
				}
			}

			return true;
		},


		isTimeEndValid() {
			if (!this.time_end) {
				return false;
			}
			let hours = this.time_end.split(':')[0];
			if (hours == 'HH') {
				return false;
			}

			if (!this.time_end || this.time_end == null) {
				return false;
			}
			return true;
		},


		isNameValid() {
			if (this.name.length < 3) {
				return false;
			}

			return true;
		},


		isSurnameValid() {
			if (this.surname.length < 2) {
				return false;
			}

			return true;
		},


		isAddressValid() {
			if (this.address.length < 3) {
				return false;
			}
			return true;
		},


		isAddressApartmentValid() {
			// if (this.address_apartment.length < 3) {
			// 	return false;
			// }
			return true;
		},


		isAddressCityValid() {
			if (this.address_city.length < 3) {
				return false;
			}
			return true;
		},

		isAddressStateValid() {
			//return true; // отключили необходимость быть обязательным полем
			if (this.address_state.length < 2) {
				return false;
			}
			return true;
		},




		isAddressZipValid() {
			if (this.address_zip.length < 3) {
				return false;
			}
			return true;
		},

		isPhoneValid() {
			if (this.phone.length < 4) {
				this.isPhoneErr = true;
				return false;
			}
			return true;
		},

		isWhatsAppValid() {
			// check if age not less than 18
			if (!this.isPhoneValid) {
				return false;
			}

			if (this.isPhoneValid && !Number(this.whats_app)) {
				return false;
			}
			return true;
		},

		isPhoneWithWhatsAppValid() {
			if (!this.isPhoneValid || !this.isWhatsAppValid) {
				return false;
			}
			return true;
		},


		isPhone2Valid() {
			if (this.phone2.length < 4) {
				this.isPhone2Err = true;
				return false;
			}
			return true;
		},

		isWhatsApp2Valid() {
			// check if age not less than 18
			if (this.phone2.length && !Number(this.whats_app2)) {
				return false;
			}

			if (!this.isPhone2Valid) {
				return false;
			}

			if (this.phone2.length && Number(this.whats_app2)) {
				return true;
			}

			if (!this.phone2.length) {
				return true;
			}
			return false;
		},


		isPhoneWithWhatsApp2Valid() {
			if (!this.isPhone2Valid || !this.isWhatsApp2Valid) {
				return false;
			}
			return true;
		},

		isPhone1oRPhone2WithWhatsAppValid() {
			if (

				(this.isPhoneWithWhatsAppValid  || (this.isPhoneWithWhatsApp2Valid && this.phone2.length > 7))
			) {
				return true;
			}
			return false;
		},

		isEmailValid() {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(this.email).toLowerCase());
		},

		isPhotosValid() {
			if (!this.photos.length) {
				return false;
			}
			return true;
		},



		daysAfterFree() {
			// days_after_free
			if (this.isDateEndValid) {
				// number of days between end date and date of date_free
				console.log('date_start  and date_free_fixed: ' + this.date_start + '-' + this.date_free_fixed)
				let start =  new Date(this.date_start);
				let free = new Date(this.date_free_fixed);

				var Difference_In_Time = start.getTime() - free.getTime();
				var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
				console.log('Difference_In_Days: ' + Difference_In_Days);

				return Difference_In_Days;
			}
			return 0;
		},

		isStartDateNotToLate() {
			// days_before_start
			if (this.isDateStartValid) {
				if (this.daysAfterFree > this.days_before_start) {
					return false;
				} else {
					return true;
				}
			}
			return true;
		},

		isFormValid() {
			if (!this.isDateStartValid) { return false; }
			if (!this.isTimeStartValid) { return false; }
			if (!this.isDateEndValid) { return false; }
			if (!this.isTimeEndValid) { return false; }
			if (!this.isNameValid) { return false; }
			if (!this.isSurnameValid) { return false; }
			if (!this.isBirthDateValid) { return false; }
			if (!this.isPhone1oRPhone2WithWhatsAppValid) { return false; }
			if (!this.isEmailValid) { return false; }
			if (!this.isPhotosValid) { return false; }
			if (!this.isAddressValid) { return false; }
			if (!this.isAddressCityValid) { return false; }
			if (!this.isAddressStateValid) { return false; }
			if (!this.isAddressZipValid) { return false; }
			// if (!this.isStartDateNotToLate) { return false; }
			return true;
		},

		js_errors() {
			let errors = [];
			if (!this.isDateStartValid ||  !this.isTimeStartValid) {
				errors.push(this.t.form_error_start_date[this.locale]);
			}
			if (!this.isDateEndValid ||  !this.isTimeEndValid) {
				errors.push(this.t.form_error_end_date[this.locale]);
			}

			if (!this.isNameValid || !this.isSurnameValid)  {
				errors.push(this.t.form_error_name[this.locale]);
			}

			if (!this.isBirthDateValid) {
				errors.push(this.t.form_error_age[this.locale]);
			}


			if (!this.isPhone1oRPhone2WithWhatsAppValid) {
				errors.push(this.t.form_error_whatsApp[this.locale]);
			}

			if (!this.isEmailValid) {
				errors.push(this.t.form_error_email[this.locale]);
			}


			if (!this.isPhotosValid) {
				errors.push(this.t.form_error_photos[this.locale]);
			}
			if (!this.isAddressValid || !this.isAddressCityValid || !this.isAddressStateValid || !this.isAddressZipValid ) {
				errors.push(this.t.form_error_address[this.locale]);
			}

			return errors;
		}
	},


	watch: {

		date_start: function (val) {

			this.$set(this.flatPicker_config_end, 'minDate', new Date(moment(val)));

			if ( (this.date_end) && (this.date_end < val)) {
				//this.date_end = val;
				//this.$set(this.flatPicker_config_end, 'defaultDate', new Date(moment(val)));
				//this.date_end = '';
			}
			this.time_start = '';

		},

		time_start: function (val) {

			// val in format HH:mm
			let hours = val.split(':')[0];

			let minutes = val.split(':')[1];

			if (minutes == 'mm') {
				this.time_start = hours + ':00';
			}
			//console.log('time_start: ' + val);
		},




		time_end: function (val) {

			// val in format HH:mm
			let hours = val.split(':')[0];

			let minutes = val.split(':')[1];

			if (minutes == 'mm') {
				this.time_end = hours + ':00';
			}
			//console.log('time_end: ' + val);
		},

		phone: function (val) {
			this.isPhoneErr = val.length === 0;
			if (val && this.isPhoneValid) {
				this.sendLogs('phone input');
			}
		},

		phone2: function (val) {
			this.isPhone2Err = val.length === 0;
			if (val && this.isPhone2Valid) {
				this.sendLogs('phone2 input');
			}
		},

		comments: function (val) {
			this.isCommentsErr = val.length === 0;
		},

		menu (val) {
			val && setTimeout(() => (this.$refs.menu.$refs.agenda.mode = 'year'));
		},

		isPhoneValid (val) {
			if (val) {
				// if phone is valid and filled and phoneBecomeValid is false
				// whats_app set to 1
				if (!this.phoneBecomeValid) {
					this.whats_app = 1;
					this.phoneBecomeValid = true;
					this.sendLogs('phone input');
				}
			}
		},
		isBirthDateValid(val) {
			if (val) {
				this.sendLogs('birthday input');
			}
		},
		// isEmailValid(val) {
		// 	if (val) {
		// 		this.sendLogs();
		// 	}
		// },
		email(val) {
			if (val && this.isEmailValid) {
				this.sendLogs('email input');
			}
		},


		surname(val) {
			if (val && this.isSurnameValid) {
				this.sendLogs('surname input');
			}
		},

		photos(val) {
			if (val && this.isPhotosValid) {
				this.sendLogs('photos input');
			}
		},


	},

	methods: {

		getFullPhone(iti, localNumber) {
			if (!iti || !localNumber) return localNumber;
			const data = iti.getSelectedCountryData();
			const dialCode = data.dialCode || '';
			const cleaned = localNumber.replace(/[^0-9]/g, '');
			return '+' + dialCode + cleaned;
		},

		isHeicFile(file) {
			const name = (file && file.name ? file.name : '').toLowerCase();
			const type = (file && file.type ? file.type : '').toLowerCase();
			return type === 'image/heic' || type === 'image/heif' || name.endsWith('.heic') || name.endsWith('.heif');
		},

		isImageLikeFile(file) {
			const type = (file && file.type ? file.type : '').toLowerCase();
			const name = (file && file.name ? file.name : '').toLowerCase();
			console.log('[isImageLikeFile] Checking file:', {name, type});
			if (type.startsWith('image/')) {
				console.log('[isImageLikeFile] ✓ Detected as image by MIME type');
				return true;
			}
			if (this.isHeicFile(file)) {
				console.log('[isImageLikeFile] ✓ Detected as HEIC/HEIF');
				return true;
			}
			const isImage = name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.png') || name.endsWith('.webp');
			console.log('[isImageLikeFile]', isImage ? '✓ Detected by extension' : '✗ Not an image');
			return isImage;
		},

		toJpgName(name) {
			const base = (name || 'image')
				.replace(/\.heic$/i, '')
				.replace(/\.heif$/i, '')
				.replace(/\.jpeg$/i, '')
				.replace(/\.jpg$/i, '')
				.replace(/\.png$/i, '')
				.replace(/\.webp$/i, '');
			return base + '.jpg';
		},

		async convertHeicToJpeg(file, quality = 0.85) {
			console.log('[convertHeicToJpeg] Starting conversion for:', file.name);
			try {
				console.log('[convertHeicToJpeg] Loading heic2any library...');
				const mod = await import(/* webpackChunkName: "heic2any" */ 'heic2any');
				const heic2any = mod && mod.default ? mod.default : mod;

				console.log('[convertHeicToJpeg] Converting HEIC to JPEG...');
				const blob = await heic2any({
					blob: file,
					toType: 'image/jpeg',
					quality: quality
				});

				const jpegBlob = Array.isArray(blob) ? blob[0] : blob;
				console.log('[convertHeicToJpeg] ✓ Conversion successful, size:', jpegBlob.size);

				return new File([jpegBlob], this.toJpgName(file.name), {
					type: 'image/jpeg',
					lastModified: Date.now()
				});
			} catch (e) {
				console.warn('[convertHeicToJpeg] ✗ Conversion failed:', e);
				return null;
			}
		},

		// Пытаемся нативно декодировать в браузере (Safari часто умеет HEIC)
		async tryResizeViaBrowserDecode(file, maxWidth = 1920, maxHeight = 1920, quality = 0.8) {
			console.log('[tryResizeViaBrowserDecode] Attempting native decode for:', file.name);
			let url = null;

			try {
				url = URL.createObjectURL(file);

				let imgWidth = 0;
				let imgHeight = 0;
				let drawSource = null;

				// 1) createImageBitmap (если поддерживается)
				if (typeof createImageBitmap === 'function') {
					console.log('[tryResizeViaBrowserDecode] Using createImageBitmap...');
					const bitmap = await createImageBitmap(file);
					imgWidth = bitmap.width;
					imgHeight = bitmap.height;
					drawSource = bitmap;
					console.log('[tryResizeViaBrowserDecode] Decoded via bitmap:', imgWidth, 'x', imgHeight);
				} else {
					// 2) fallback на <img>
					console.log('[tryResizeViaBrowserDecode] Using Image fallback...');
					const img = await new Promise((resolve, reject) => {
						const i = new Image();
						i.onload = () => resolve(i);
						i.onerror = reject;
						i.src = url;
					});
					imgWidth = img.naturalWidth || img.width;
					imgHeight = img.naturalHeight || img.height;
					drawSource = img;
					console.log('[tryResizeViaBrowserDecode] Decoded via Image:', imgWidth, 'x', imgHeight);
				}

				if (!imgWidth || !imgHeight) {
					console.log('[tryResizeViaBrowserDecode] ✗ Failed to get image dimensions');
					return null;
				}

				let width = imgWidth;
				let height = imgHeight;

				if (width > maxWidth || height > maxHeight) {
					const aspect = width / height;
					if (width > height) {
						width = maxWidth;
						height = Math.round(width / aspect);
					} else {
						height = maxHeight;
						width = Math.round(height * aspect);
					}
					console.log('[tryResizeViaBrowserDecode] Resizing to:', width, 'x', height);
				}

				const canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;

				const ctx = canvas.getContext('2d');
				ctx.drawImage(drawSource, 0, 0, width, height);

				const blob = await new Promise((resolve) => {
					if (!canvas.toBlob) return resolve(null);
					canvas.toBlob((b) => resolve(b), 'image/jpeg', quality);
				});

				if (!blob) {
					console.log('[tryResizeViaBrowserDecode] ✗ Failed to create blob');
					return null;
				}

				console.log('[tryResizeViaBrowserDecode] ✓ Native decode successful, size:', blob.size);
				return new File([blob], this.toJpgName(file.name), {
					type: 'image/jpeg',
					lastModified: Date.now()
				});
			} catch (e) {
				console.log('[tryResizeViaBrowserDecode] ✗ Native decode failed:', e.message);
				return null;
			} finally {
				if (url) URL.revokeObjectURL(url);
			}
		},

		async processToResizedJpeg(file) {
			console.log('[processToResizedJpeg] Processing file:', file.name, 'type:', file.type);
			// 1) HEIC: сначала пробуем нативно (без libheif) -> JPEG+resize
			if (this.isHeicFile(file)) {
				console.log('[processToResizedJpeg] Detected HEIC file, trying native decode first...');
				const nativeResized = await this.tryResizeViaBrowserDecode(file, 1920, 1920, 0.8);
				if (nativeResized) {
					console.log('[processToResizedJpeg] ✓ HEIC processed via native decode');
					return nativeResized;
				}

				// 2) если нативно не смогли — конвертим heic2any -> потом resizeImage
				console.log('[processToResizedJpeg] Native decode failed, trying heic2any...');
				const converted = await this.convertHeicToJpeg(file, 0.9);
				if (!converted) {
					console.log('[processToResizedJpeg] ✗ HEIC conversion failed completely');
					return null;
				}

				// resizeImage у вас и так выдаёт image/jpeg (через canvas)
				console.log('[processToResizedJpeg] HEIC converted, now resizing...');
				const resized = await this.resizeImage(converted, 1920, 1920, 0.8);
				console.log('[processToResizedJpeg] ✓ HEIC processed via heic2any + resize');
				// гарантируем имя .jpg
				return new File([resized], this.toJpgName(file.name), {
					type: 'image/jpeg',
					lastModified: Date.now()
				});
			}

			// Обычные форматы: просто resize -> JPEG
			console.log('[processToResizedJpeg] Standard image, resizing...');
			const resized = await this.resizeImage(file, 1920, 1920, 0.8);
			console.log('[processToResizedJpeg] ✓ Standard image processed, size:', resized.size);
			return new File([resized], this.toJpgName(file.name), {
				type: 'image/jpeg',
				lastModified: Date.now()
			});
		},

		async resizeImage(file, maxWidth = 1920, maxHeight = 1920, quality = 0.8) {
			return new Promise((resolve) => {
				// If not an image, return original
				if (!file.type.match('image')) {
					resolve(file);
					return;
				}

				const reader = new FileReader();
				reader.onload = (e) => {
					const img = new Image();
					img.onload = () => {
						try {
							// Calculate new dimensions while maintaining aspect ratio
							let width = img.width;
							let height = img.height;

							if (width > maxWidth || height > maxHeight) {
								const aspectRatio = width / height;
								if (width > height) {
									width = maxWidth;
									height = width / aspectRatio;
								} else {
									height = maxHeight;
									width = height * aspectRatio;
								}
							}

							// Create canvas and resize
							const canvas = document.createElement('canvas');
							canvas.width = width;
							canvas.height = height;
							const ctx = canvas.getContext('2d');
							ctx.drawImage(img, 0, 0, width, height);

							// Try modern toBlob API first
							if (canvas.toBlob) {
								canvas.toBlob(
									(blob) => {
										if (blob) {
											const resizedFile = new File([blob], file.name, {
												type: 'image/jpeg',
												lastModified: Date.now()
											});
											resolve(resizedFile);
										} else {
											resolve(file);
										}
									},
									'image/jpeg',
									quality
								);
							} else {
								try {
									const dataUrl = canvas.toDataURL('image/jpeg', quality);
									const blob = this.dataURLtoBlob(dataUrl);
									const resizedFile = new File([blob], file.name, {
										type: 'image/jpeg',
										lastModified: Date.now()
									});
									resolve(resizedFile);
								} catch (error) {
									console.error('Image resize fallback failed:', error);
									resolve(file);
								}
							}
						} catch (error) {
							console.error('Image resize failed:', error);
							resolve(file);
						}
					};

					img.onerror = () => {
						console.error('Image load failed');
						resolve(file);
					};

					img.src = e.target.result;
				};

				reader.onerror = () => {
					console.error('FileReader failed');
					resolve(file);
				};

				reader.readAsDataURL(file);
			});
		},

		dataURLtoBlob(dataURL) {
			const arr = dataURL.split(',');
			const mime = arr[0].match(/:(.*?);/)[1];
			const bstr = atob(arr[1]);
			let n = bstr.length;
			const u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		},

		async sendLogs(action = 'input') {
			let formData = new FormData();
			formData.append('current_locale',this.locale);
			formData.append('phone',this.getFullPhone(this.iti1, this.phone));
			formData.append('phone2',this.getFullPhone(this.iti2, this.phone2));
			formData.append('whats_app',this.whats_app);
			formData.append('whats_app2',this.whats_app2);
			formData.append('name',this.name);
			formData.append('surname',this.surname);
			formData.append('birthdate',this.birthdate);
			formData.append('email',this.email);
			formData.append('address',this.address);
			formData.append('address_apartment',this.address_apartment);
			formData.append('address_city',this.address_city);
			formData.append('address_state',this.address_state);
			formData.append('address_zip',this.address_zip);
			formData.append('chairs',this.chairs);
			formData.append('comment',this.comment);
			formData.append('flight',this.flight);
			formData.append('date_start',JSON.stringify(this.date_start));
			formData.append('date_end',JSON.stringify(this.date_end));
			formData.append('time_start',JSON.stringify(this.time_start));
			formData.append('time_end',JSON.stringify(this.time_end));
			formData.append('id',this.id);
			formData.append('car_name',this.car_name);
			formData.append('lot_number',this.lot_number);
			formData.append('errors',JSON.stringify(this.js_errors));
			formData.append('warnings',JSON.stringify(this.server_warnings));
			formData.append('price',this.price);
			formData.append('action',action);
			// if exists photos send onfo about number of photos
			formData.append('photos_num',this.photos.length);


			// request post to server
			await axios.post('/requestCustomerdataFormLogs', formData).then( (response) => {
				//console.log(response.data);
			}).catch( (error) => {
				console.log(error);
			});

		},

		timeIsAvailable(val) {
			if (!this.date_free) {
				return true;
			}

			// current_time  from  val in time format 05:30 AM
			let current_time = moment(val, "hh:mm A").format('HH:mm:ss');
			let date_free = this.date_free.split(' ')[0];
			let time_free = this.date_free.split(' ')[1];
			// time free to format from 05:30:00 to  05:30 AM
			//time_free = moment(time_free, "HH:mm:ss").format('hh:mm A');
			//console.log('checking time free: ' + time_free);


			let date_start = this.date_start;

			// if date_start the same date as date_free
			if (date_free == date_start) {
				// check if val tile is not before time_free
				//console.log('current_time: ' + current_time);
				if (current_time < time_free) {
					//console.log('current_time disabled: ' + current_time);
					return false;
				}
			}

			return true;
		},


		isTodayInMiami(dateString) {
			// Get current date and time
			var now = new Date();
			// Calculate the offset for Miami (Eastern Time, UTC-5)
			var offset = now.getTimezoneOffset() + (5 * 60);
			// Get the current date and time in Miami
			var nowInMiami = new Date(now.getTime() - (offset * 60 * 1000));
			// Format the current date in Miami to YYYY-MM-DD
			var todayInMiami = nowInMiami.toISOString().split('T')[0];
			// Compare the given date with today's date in Miami
			return dateString === todayInMiami;
		},


		sendForm() {
			//console.log('sending...');

			this.sendLogs('button clicked');

			this.send_clicked = true;

			if (this.sending) {
				return;
			}

			if (!this.isFormValid) {
				var loc = document.location.toString().split('#')[0];
				document.location = loc + '#customerFormTop';
				return;
			}

			this.sending = true;

			var formData = new FormData();
			formData.append('current_locale',this.locale);
			formData.append('phone',this.getFullPhone(this.iti1, this.phone));
			formData.append('phone2',this.getFullPhone(this.iti2, this.phone2));
			formData.append('whats_app',this.whats_app);
			formData.append('whats_app2',this.whats_app2);
			formData.append('name',this.name);
			formData.append('surname',this.surname);
			formData.append('birthdate',this.birthdate);
			formData.append('email',this.email);
			formData.append('address',this.address);
			formData.append('address_apartment',this.address_apartment);
			formData.append('address_city',this.address_city);
			formData.append('address_state',this.address_state);
			formData.append('address_zip',this.address_zip);
			formData.append('chairs',this.chairs);
			formData.append('comment',this.comment);
			formData.append('flight',this.flight);
			formData.append('date_start',JSON.stringify(this.date_start));
			formData.append('date_end',JSON.stringify(this.date_end));
			formData.append('time_start',JSON.stringify(this.time_start));
			formData.append('time_end',JSON.stringify(this.time_end));
			formData.append('id',this.id);
			formData.append('car_name',this.car_name);
			formData.append('lot_number',this.lot_number);



			this.filesToUpload.forEach((file, index) => {
				let new_file_name = '' + index + '-' + file.name;
				formData.append('file[]', file, new_file_name);
			});


			axios.post('/requestCustomerdataForm', formData).then( (response) => {
				//console.log(response.data);
				this.sending = false;

				if (response.data.result && response.data.result == true) {

					this.sent = true;

					setTimeout(() => {
						location.hash = "#" + 'sentTop';
					}, 200);

					if (response.data.warnings) {
						this.server_warnings = response.data.warnings;
					}

					// check if ym is defined
					if (typeof ym !== 'undefined') {
						// send goal to ym
						ym(56181382,'reachGoal','reservation');
					}

					// GTM: conversion for Google Ads / GA4 — fired on an accepted form,
					// not on a button click. GTM is loaded only on production,
					// so create dataLayer ourselves when it is missing.
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({ event: 'booking_submitted', value: Number(this.priceTotal), currency: 'USD' });

				} else {
					if (response.data.errors) {
						this.server_errors = response.data.errors;
					}
				}


			}).catch( (error) => {
				this.sending = false;
				console.log(error);
				//alert(error);
			});
		},

		// readURL: async function(input) {
		// 	//console.log('read url');
		// 	var files = input.files;
		// 	for (var i = 0; i < files.length; i++) {
		// 		let file = files[i];
		// 		//Only pics
		// 		if (!file.type.match('image')) continue;
		//
		// 		// Resize image before upload
		// 		const resizedFile = await this.resizeImage(file);
		//
		// 		// Create preview using FileReader
		// 		var picReader = new FileReader();
		// 		picReader.addEventListener("load", (event) => {
		// 			var picFile = event.target;
		// 			// Add resized file to upload queue
		// 			this.filesToUpload.push(resizedFile);
		// 			// Add preview
		// 			this.addPhoto(picFile.result, file.name);
		// 		});
		// 		//Read the image for preview
		// 		picReader.readAsDataURL(file);
		// 	}
		//
		// },

		readURL: async function(input) {
			console.log('[readURL] Starting file processing, total files:', input.files.length);
			try {
				var files = input.files;
				for (var i = 0; i < files.length; i++) {
					const original = files[i];
					console.log('[readURL] File', i+1, '/', files.length, ':', original.name);

					if (!this.isImageLikeFile(original)) {
						console.log('[readURL] ⊘ Skipping non-image file:', original.name);
						continue;
					}

					console.log('[readURL] Processing image file...');
					const resizedJpeg = await this.processToResizedJpeg(original);
					if (!resizedJpeg) {
						// Тут можно показать пользователю сообщение "не удалось обработать HEIC"
						console.warn('[readURL] ✗ Skip file, cannot convert/resize:', original && original.name);
						continue;
					}

					console.log('[readURL] ✓ File processed successfully:', resizedJpeg.name, 'size:', resizedJpeg.size);
					var picReader = new FileReader();
					picReader.addEventListener("load", (event) => {
						var picFile = event.target;
						this.filesToUpload.push(resizedJpeg);
						this.addPhoto(picFile.result, resizedJpeg.name);
						console.log('[readURL] ✓ Photo added to upload queue:', resizedJpeg.name);
					});
					picReader.readAsDataURL(resizedJpeg);
				}
				console.log('[readURL] ✓ All files processed');
			} catch (e) {
				console.error('[readURL] ✗ Fatal error:', e);
			}
		},

		addPhoto(src, name) {
			//console.log('add:' + name);
			// this.photos.push({
			// 	"src": src,
			// 	"name": name
			// });

			// this.photos = [...this.photos, {
			// 	src: src,
			// 	name: name
			// }];
			this.$nextTick(() => {
				this.photos = [...this.photos, {
					src: src,
					name: name
				}];
			});


			//console.log(this.photos);
			//console.log(this.filesToUpload);
		},

		removePhoto(index) {
			//console.log(index);
			//this.photos.splice(index, 1);

			// remove from array by index
			this.photos.splice(index, 1);
			this.filesToUpload.splice(index, 1);


			//console.log(this.filesToUpload);

			// чистим инпут т.к. если после удаления картинки человек выберет повторно туже картинку, не произойден событие on change
			$("#inputFile").empty();
			$("#inputFile").val(null);
		},
		getPopoverCustomTemplate(className) {
			return '<div class="popover ' + className + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
		},

		selectPhotos(e) {
			//console.log('input vue change');
			this.readURL(e.currentTarget);
		},


	},

	created() {
		// Set default value for address_state
		this.address_state = this.t.address_state_default[this.locale];
	},

	mounted() {


		$(() => {

			let date_free = new Date(this.date_free ? this.date_free : new Date());
			//console.log('date free' + date_free);
			let today2 = new Date();
			//console.log(today2);


			if (date_free < today2) {
				// convert date to format yyyy-mm-dd
				this.date_free_fixed = today2.getFullYear() + '-' + (today2.getMonth() + 1) + '-' + today2.getDate();
			} else {
				this.date_free_fixed = this.date_free ? this.date_free :  today2.getFullYear() + '-' + (today2.getMonth()+1) + '-' + today2.getDate();
			}
			//console.log(this.date_free_fixed);

		});

		// intl-tel-input: phone 1 — US by default
		this.iti1 = intlTelInput(this.$refs.phoneInput1, {
			initialCountry: 'us',
			separateDialCode: true,
			preferredCountries: ['us', 'ca', 'mx', 'br', 'co'],
			dropdownContainer: document.body,
		});

		// intl-tel-input: phone 2 — auto-detect country by IP
		this.iti2 = intlTelInput(this.$refs.phoneInput2, {
			initialCountry: 'auto',
			separateDialCode: true,
			preferredCountries: ['us', 'ca', 'mx', 'br', 'co'],
			dropdownContainer: document.body,
			geoIpLookup: function(success, failure) {
				fetch('https://ipapi.co/json')
					.then(res => res.json())
					.then(data => success(data.country_code))
					.catch(() => success('us'));
			},
		});

	},

	beforeDestroy() {
		if (this.iti1) this.iti1.destroy();
		if (this.iti2) this.iti2.destroy();
	}
}
</script>


<style lang="scss">
.iti__flag {background-image: url("/build/customer_car_form_v2/flags.png");}
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
	.iti__flag {background-image: url("/build/customer_car_form_v2/flags@2x.png");}
}
.iti__country-list {
	z-index: 999 !important;
}

.customer-car-form {
	display: inline-block;
	width:100%;
	//height:100%;
	//border:1px solid red;
	.form-anons {
		font-size: 16px;
		color:#868686;
	}
	.form-control, .form-select {
		border-radius:0px;
		&:focus {
			border:1px solid #aeb3b7;
			// disable focus
			box-shadow: none;
		}
	}
	select.form-select {
		color: #000000;
		option {
			color: #000000;
		}
		&:invalid,
		& option[value=""] {
			color:#595C5F;
		}
		border-radius:0px;
		padding-left:19px;
		&.form-select--no-padding {
			padding-left:10px;
		}
	}



	.flatpickr-wrapper {
		.form-control {
			border-radius:0px;
			padding-left:19px;
		}
	}





	// date picker
	.field {
		&.is-focused {
			.field-input {
				border:1px solid #aeb3b7 !important;
			}
		}
	}


	.vd-picker__input.vd-picker__input--no-date input {
		color: #868686;
		-webkit-text-fill-color: #282828;

	}


	.phone-wrapper {
		position: relative;

		.iti {
			width: 100%;

			.iti__flag-container {
				z-index: 2;
			}


			// override padding so text starts after flag+dialcode area
			input.form-control-required {
				padding-left: 90px !important;
			}

			&.iti--separate-dial-code input {
				padding-left: 90px !important;
			}
		}

		.phone-whatsapp-checkbox {
			position: absolute;
			display: flex;
			align-items: center;
			top: 2px;
			right: 2px;
			background-color: white;
			height: 90%;
			padding: 0 10px;
			z-index: 3;

			.form-check input[type="checkbox"] {
				transform: scale(1.5);
				box-shadow: inset 0 1px 3px rgba(0, 0, 0, .3);
			}

			.form-check .form-check-label {
				padding-left: 5px;
			}
		}

		.form-control.is-invalid {

			background-color: white !important;

		}

	}

	.form-control-required-wrapper {
		display: flex;
		width:100%;
		align-items: stretch;
		.display-time {
			height:42px !important;
		}

		&.is-invalid.invalid-file-wrapper {
			.form-control {
				background-color: #FFC0C0;
				background-image: none;
				border:1px solid #C00000;
				.input-group-label {
					color:#594C4F !important;
				}
			}


		}
		&.is-invalid {

			.field-input {
				background-color: #FFC0C0;
				background-image: none;
				border:1px solid #C00000;
			}

			// своя обертка для времени
			input.display-time {
				background-color: #FFC0C0;
				background-image: none;
				border:1px solid #C00000;
			}
			// своя обертка для поля даты рождения
			.vd-wrapper {
				background-color: #FFC0C0;
				background-image: none;
				border:1px solid #C00000;
			}

		}
		.form-control-required-star {
			//position: relative;
			display: inline-block;
			text-align: center;
			width:11px;
			//padding:1px;
			margin-right:-11px;
			//height:100% !important;
			//border:1px solid green;
			z-index: 2;
			border:1px solid transparent;
			.star {
				display: flex;
				align-items: flex-start;
				justify-content: center;
				height:100%;
				background-color: #FFC0C0;
				font-size:14px;
				color:white;
				width:100%;
				&.star-valid {
					//background-color: #0096ED;
					background-color: #2eb74e;

				}
			}
		}
		.form-control-required,
		.field-input
		{

			padding-left:18px !important;
			//text-indent: 50px;
			//padding-left:50px !important;

			&.is-invalid {
				background-color: #FFC0C0;
				background-image: none;
			}
		}

		.input-group.file-upload {
			padding:0px;
			display: flex;
			width: 100%;
			label.input-group-label {
				flex-shrink: 1;
				flex-grow: 1;
				flex-basis: 0;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

				padding-left:18px !important;
				padding-top:6px;
				padding-bottom:6px;
				padding-right: 10px;
				color: #6a737b !important;
				//border-left:0px !important;
				&:focus {
					border:1px solid #aeb3b7 !important;
				}
				.label-text-wrapper {
					display: inline-block;
					width:100%;
					//max-width:185px;
					// overflow hidden with dots
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					@media (max-width: 375px) {
						max-width: 180px;
					}
					@media (min-width: 375px) and  (max-width: 420px) {
						max-width: 190px;
					}
				}
			}


			.input-group-text {
				flex-grow: 0;
				white-space: nowrap;
				overflow: hidden;
				//background-color: #FFFFFF;
				border-radius: 0px;
				border-top:0px;
				border-bottom:0px;
				border-right:0px;
				color: #6a737b !important;
				&::after {
					border-radius: 0px;
				}
			}
			&.is-invalid {
				background-color: #FFC0C0;
				background-image: none;
				border:1px solid #C00000 !important;
			}
		}

	}


	.custom-file-label {
		color: #6a737b !important;
		border-radius: 0px;
		&::after {
			border-radius: 0px;
		}
	}




	.photo_comments {
		color: #6a737b;
		font-size:15px;
	}
	.field-label {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.5;

		//color: #495057;
	}
	.field-input {
		border-radius: 0px;
		border: 1px solid #ced4da;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.5;
		//color: #6c757d;
	}

	.time-picker {
		width:100%;
		.display-time {
			font-size: 16px;
			font-weight: 400;
			line-height: 24px;
			width:100%;
			padding-left:18px;
			color: #262626 !important;
			padding-top:6px;
			padding-bottom:6px;
			font-family: Ubuntu, sans-serif;
			&::placeholder {
				color:#595C5F;
				opacity: 1; /* Firefox */
			}

		}
	}



	.card {
		display: inline-block;
		width:100%;
		height:100%;
		border:0px solid white;
		.card-body {
			width:100%;
			height:100%;
			padding:0;
			.order-form {
				position: relative;
				display: flex;
				flex-direction: column;
				width:100%;
				//height:100%;
				//padding-bottom:55px;
				//border:1px solid gray;
				.mb-2 {
					flex-grow: 0;
					.input-group {
						.input-group-append {
							border-radius: 0px;
							.input-group-text {
								border-radius: 0px;
							}
						}
					}
				}
				.form-control {
					//outline: none;
					&:focus {

					}
				}
				.mb-2-note {
					flex-grow: 1;
					padding-bottom:50px;
					//border:1px solid lightgrey;
					.note {
						height: 100%;
						min-height:120px;
					}
				}
				.mb-2-order-btn {
					//position: absolute;
					//bottom:0px;
					//left:0px;
					width:100%;
					text-align:center;
					padding:0;
					margin:0;
					.btn-primary {
						outline: none;
						box-shadow: none;
					}
				}
				.photos-wrapper {
					display: flex;
					justify-content: flex-start;
					flex-wrap: wrap;
					.photo-wr {
						position: relative;
						width:25%;
						display: inline-block;
						padding-left: 2px;
						padding-right: 2px;
						&:nth-child(4) {
							//padding-right: 0px;
							//padding-bottom: 3px;
						}
						.photo-holder {
							position: relative;
							height: 0;
							padding-bottom: 100%;
							background-color: lightgrey;
							.photo {
								position: absolute;
								height:100%;
								width:100%;
								display: flex;
								align-items: center;
								img {
									display: block;
									width:100%;
									height:100%;
									//max-width:100%;
									object-fit: cover;
								}
							}

							.btn-delete {
								position: absolute;
								top:3px;
								right:3px;
								padding:3px 5px !important;
								color:gray;
								font-size:20px;
								line-height:20px;
							}
						}

					}
				}
			}

		}
	}


	.price-row {
		font-size:24px;
		.price-num {
			font-size:32px;
		}
	}

	.box-sent {
		position: relative;
		display: inline-block;
		width:100%;
		height:#{calc(100% - 55px)};

		padding:35px 25px 100px 25px;
		border: 1px solid lightgrey;
		font-size:18px;
		color:black;
		text-align:center !important;
		.sent-text-top {
			font-size:16px;
			line-height:30px;
			text-align:center;
		}
		.sent-text2 {
			font-size:16px;
			line-height:30px;
			text-align:center;
		}
		.sent-icon {
			font-size: 78px;
			line-height:64px;
			//color: #6CA3EC;
			color: #16712B;
			text-align:center;
			&--warning {
				color: #F9AF00;
			}
		}
		.btn-ok-wr {
			display: inline-block;
			position: absolute;
			bottom:0;
			left:0;
			width:100%;
			text-align: center;
			padding:35px 25px;
			a {
				text-decoration: none;
				&:hover {
					text-decoration: none;
				}
			}
		}

	}

	input:hover {
		cursor: pointer;
	}
	textarea:hover {
		cursor: pointer;
	}

	// поле выбора дата отключаем эффект hover чтобы крестик не выделялся относительно других
	.field-clear-button {
		.custom-button-effect {
			display: none !important;
		}
		.custom-button-content {
			color: rgba(0, 0, 0, 0.54) !important;
			.fs-16 {
				color: rgba(0, 0, 0, 0.54) !important;
			}
		}
	}

	// поле выбора времени, перебиваем дефолтные стили кнопки закрытия чтобы было как у полей где дата выбирается
	.vue__time-picker.time-picker {
		.controls {
			right:11px;
			.clear-btn {
				.char {
					color: rgba(0, 0, 0, 0.54) !important;
					font-family: Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
					font-size: 24px !important;
					cursor: pointer;
					fill: rgba(0, 0, 0, 0.54);
					font-weight: 300;
					line-height: 19.5px;
					text-transform: uppercase !important;
				}
			}
		}
	}




	// настройка единого крестика по полю выбора дня рождения
	.vd-picker__input-clear {
		margin-top: 7px;
		.vd-icon.vd-icon--link {
			// color black to svg
			svg {
				color: rgba(0, 0, 0, 0.6) !important;
				fill: rgba(0, 0, 0, 0.6) !important;
				stroke-width: 1px;
				opacity: 0.7 !important;
			}
		}
	}

	.data_is_secure {
		i {
			color: rgb(40, 167, 69);
		}
		.secure-title {
			font-size:22px;
			line-height:28px;
		}

	}

}

.info-popover {
	border:0px  !important;
	border-radius:0px !important;
	color: #005F96 !important;
	box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1) !important;
	.popover-body {
		color:#005F96;
		font-size:14px;
	}
	.arrow {
		display: none;
	}
}
</style>
